export const agentManageKeys = {
  all: ['agent', 'manage'],
  agentsList: (
    searchQuery: string,
    filters: Record<string, string[]>,
    sort: Record<string, string>,
    limit: number
  ) => [
    ...agentManageKeys.all,
    'agentsList',
    searchQuery,
    filters,
    sort,
    limit,
  ],
  filterOptions: (target: string, searchQuery: string, limit: number) => [
    ...agentManageKeys.all,
    'filterOptions',
    target,
    searchQuery,
    limit,
  ],
  labels: (searchText: string, max: number) => [
    ...agentManageKeys.all,
    'labels',
    searchText,
    max,
  ],
  agentIdentityList: (params?: { searchText?: string }) => [
    ...agentManageKeys.all,
    'agentIdentityList',
    params,
  ],
};
